<template>
  <div class="content">
    <img :src="banner" class="banner-img" alt="" />
    <div class="sku-title">{{good_name}}</div>
    <div class="sku-hint" v-if="list != ''">规格参数</div>
    <div class="border-box" v-if="list != ''">
      <!--     <div class="title-box justify-align" v-if="list != ''">-->
      <!--        <div class="title-box-item">商品名称</div>-->
      <!--       <div class="title-box-item title-box-item-sec">{{good_name}}</div>-->
      <!--     </div>-->
      <div class="title-box justify-align" v-if="list != ''">
        <div class="title-box-item">商品编码</div>
        <div class="title-box-item title-box-item-sec">{{good_number}}</div>
      </div>
      <div class="item-box justify-align" v-for="(item,index) in list" :key="index">
        <div class="title">{{item.label}}</div>
        <div class="title-content">{{item.value}}</div>
      </div>
    </div>
    <div class="hint" v-if="list== ''" style="margin-top: 6.66667vw;">本次查询结果为非官方授权的产品，请向平台客服反馈</div>
    <div v-if="list != ''" class="hint">本次查询结果为官方授权的产品</div>
  </div>
</template>

<script>
import { goodsSku } from '@/api/goods'
export default {
  name: "goodsSpecification",
  data(){
    return{
      list: [],
      good_id:'',
      good_name:'',
      good_number:'',
      banner:''
    }
  },
  created() {
    this.good_id = this.$route.params.id
    console.log(this.$route.params.id)
    this.getDes()
  },
  methods: {
    getDes(){
      goodsSku(this.good_id).then(res => {
        if(res.code == 200)
        {
          if (res.data != ''){
            this.list = res.data.other_attributes
            // console.log('list',this.list)
            this.good_number = res.data.sku
            this.good_name = res.data.name
            this.banner = res.data.goods_image
          }

        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.van-divider{
  margin: 0.22667rem 0;
}
.sku-hint{
  color: #969799;padding: 20px 22px;font-size: 26px;
}
.banner-img{
  width: 100%;height: auto;display: block;
}
.sku-title{
  padding: 20px;text-align: center;font-size: 30px;
}
.title-box-item-sec{
  width: 70%;text-align: left;color: #666;
}
.title-box{
  padding: 15px 22px;border-bottom: 2px solid #F5F5F5;
}
.border-box{
  border: 1px solid #F5F5F5;
  //margin: 30px 30px 10px;
  background: #FFFFFF;
  .item-box{
    padding: 15px 22px;border-bottom: 2px solid #F5F5F5;
    .title{
      color: #000;width: 30%;
    }
    .title-content{
      color: #666;text-align: left;width: 70%;
    }
  }
}
.hint{
  padding: 10px 22px 30px;color: #f83e3e;font-size: 26px;
}
</style>
